export default __webpack_public_path__ + "static/media/Rectangle 5.5c4cf7ba.svg";